const local = {
  apiGateway: {
    URL: "wss://e7caq5wpz1.execute-api.us-west-2.amazonaws.com/production",
  },
  api: {
    // URL: "http://localhost:8000/",
    URL: "https://api.wannafake.me/",
  },
  tagManager: {
    gtmId: "GTM-NPZVR3N",
  },
};

const staging = {
  apiGateway: {
    URL: "wss://e7caq5wpz1.execute-api.us-west-2.amazonaws.com/production",
  },
  api: {
    URL: "https://api.wannafake.me/",
  },
  tagManager: {
    gtmId: "GTM-NPZVR3N",
  },
};

const prod = {
  apiGateway: {
    URL: "wss://trkvtl9ag9.execute-api.eu-west-3.amazonaws.com/production",
  },
  api: {
    URL: "https://api.wannafake.com/",
  },
  tagManager: {
    gtmId: "GTM-K64FN5P",
  },
};

const config_ =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "staging"
    ? staging
    : local;

export const config = {
  // Common config values here
  MAX_ITEMS: 50,
  DAYS_LEFT_WARNING: -1,
  ...config_,
};

export default config;
